var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_icons",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M11,3a7.967,7.967,0,0,0-8,8,8.283,8.283,0,0,0,1.422,4.533L3.178,17.667a.807.807,0,0,0,0,.889A.792.792,0,0,0,3.889,19H11A8,8,0,0,0,11,3Zm0,14.222H5.489l.8-1.333a.8.8,0,0,0-.089-.978A6.2,6.2,0,1,1,11,17.222Z",
    transform: "translate(-3 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M12.1,7.3H12A2.813,2.813,0,0,0,9.6,8.6.9.9,0,0,0,9.8,10a.984.984,0,0,0,1.4-.3.909.909,0,0,1,.8-.4h.1a.9.9,0,0,1,.9.9,1.013,1.013,0,0,1-.6.9l-.7.2a.961.961,0,0,0-.7.9V13a.945.945,0,0,0,1,1,.987.987,0,0,0,1-.9,2.913,2.913,0,0,0,2-2.8A2.989,2.989,0,0,0,12.1,7.3Z",
    transform: "translate(-4.029 -3.761)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(7 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIco);
export default __webpack_public_path__ + "static/media/Support_ico.bfdc2dc038997ff24f9f4ed81f982a25.svg";
export { ForwardRef as ReactComponent };